import type { SportsCmsBannerWidgetState } from './types';

export const defaultState: SportsCmsBannerWidgetState = {
  isLoading: true,
  hasPreloaded: false,
  error: undefined,
  banners: []
};
